import { ComponentType } from 'react';

export interface IRegisteredPage {
  /** Route path, relative to the application root and without a leading slash. */
  path: string;
  /** Label shown in the navigation. */
  title: string;
  /** Optional navigation group to nest under. Ungrouped pages sit at the top level. */
  group?: string;
  /**
   * Whether the page appears in the navigation. A page whose path carries
   * parameters is reachable but has nothing to link to, so it opts out.
   */
  inNavigation?: boolean;
  component: ComponentType;
}

const pages: IRegisteredPage[] = [];

/**
 * Adds pages to the application's navigation and router.
 *
 * Registration happens at module load, before the router is built, so an
 * installed extension's pages exist from the first render.
 */
export const registerPluginPages = (registered: IRegisteredPage[]): void => {
  registered.forEach((page) => {
    const isAlreadyRegistered = pages.some((existing) => existing.path === page.path);
    if (isAlreadyRegistered) {
      return;
    }

    pages.push(page);
  });
};

export const getPluginPages = (): IRegisteredPage[] => pages;

export const clearPluginPages = (): void => {
  pages.length = 0;
};
